import * as React from 'react';

/** Render the assistant's inline emphasis as React text, without interpreting HTML. */
export function AssistantText({ text }: { text: string }) {
  const parts: React.ReactNode[] = [];
  let cursor = 0;
  for (const match of text.matchAll(/\*\*([^*\n]+)\*\*/g)) {
    const start = match.index;
    if (start > cursor) {
      parts.push(<React.Fragment key={`text-${cursor}`}>{text.slice(cursor, start)}</React.Fragment>);
    }
    parts.push(<strong key={`bold-${start}`}>{match[1]}</strong>);
    cursor = start + match[0].length;
  }
  if (cursor < text.length) {
    parts.push(<React.Fragment key={`text-${cursor}`}>{text.slice(cursor)}</React.Fragment>);
  }
  return <span className="whitespace-pre-wrap break-words">{parts}</span>;
}
